import { createFileRoute } from '@tanstack/react-router';
import { HomeRedirect } from '@/features/session';

export const Route = createFileRoute('/_auth/')({
  component: HomeRedirect,
});
